import { type IIconsVector } from 'shared/ui'

export type ICreditUsageSourceGroupOption = {
  id: string
  label: string
  icon?: IIconsVector
  iconColor?: string
  keys: string[]
}

export const CREDIT_USAGE_SOURCE_GROUPS: ICreditUsageSourceGroupOption[] = [
  { id: 'broadcast', label: 'Broadcast', icon: 'broadcasts', keys: ['broadcast'] },
  { id: 'workflow', label: 'Workflow', icon: 'workflows', keys: ['workflow'] },
  { id: 'campaign', label: 'Campaign', icon: 'campaigns', keys: ['workflow_campaign'] },
  { id: 'trigger', label: 'Trigger', icon: 'lightning2', keys: ['trigger'] },
  {
    id: 'chatbot',
    label: 'AI Texting Agent',
    icon: 'stars',
    keys: ['chatbot', 'chatbot_inbound', 'chatbot_outbound'],
    iconColor: 'var(--purple-70)',
  },
  {
    id: 'ai_calling_agent',
    label: 'AI Calling Agent',
    icon: 'stars',
    keys: ['ai_calling_agent'],
    iconColor: 'var(--purple-70)',
  },
  { id: 'manual', label: 'Manual', icon: 'messageTextCircle02', keys: ['manual'] },
  {
    id: 'calls',
    label: 'Calls',
    icon: 'phone',
    keys: [
      'call_inbound',
      'call_transcript',
      'call_outbound',
      'call_ai_calling_agent',
      'call_forwarded',
    ],
  },
  { id: 'email_to_sms', label: 'Email to SMS', icon: 'email', keys: ['email_to_sms'] },
  { id: 'hubspot_manual', label: 'HubSpot Manual', icon: 'hubspot', keys: ['hubspot_manual'] },
  { id: 'hs_workflow', label: 'HubSpot Workflow', icon: 'hubspot', keys: ['hs_workflow'] },
  { id: 'hs_trigger', label: 'HubSpot Trigger', icon: 'hubspot', keys: ['hs_trigger'] },
  { id: 'is_trigger', label: 'Keap Trigger', icon: 'infusionsoft', keys: ['is_trigger'] },
  {
    id: 'salesforce_manual',
    label: 'Salesforce Manual',
    icon: 'salesforce',
    keys: ['salesforce_manual'],
  },
  {
    id: 'sf_send_message_action',
    label: 'Salesforce Automation',
    icon: 'salesforce',
    keys: ['sf_send_message_action'],
  },
  { id: 'sf_trigger', label: 'Salesforce Trigger', icon: 'salesforce', keys: ['sf_trigger'] },
  {
    id: 'activecampaign_workflow',
    label: 'ActiveCampaign Workflow',
    icon: 'activecampaign',
    keys: ['activecampaign_workflow'],
  },
  {
    id: 'ac_trigger',
    label: 'ActiveCampaign Trigger',
    icon: 'activecampaign',
    keys: ['ac_trigger'],
  },
  {
    id: 'manual_widget_pd',
    label: 'Pipedrive Manual',
    icon: 'pipedriveBlack',
    keys: ['manual_widget_pd'],
  },
  { id: 'slack', label: 'Slack', icon: 'slack', keys: ['slack'] },
  { id: 'zapier', label: 'Zapier', icon: 'zapier', keys: ['zapier'] },
  { id: 'zipwhip', label: 'Zipwhip', icon: 'zipwhip', keys: ['zipwhip'] },
  { id: 'inbound', label: 'Inbound', icon: 'messageTextCircle02', keys: ['inbound'] },
  { id: 'other', label: 'Others', icon: 'moreVertical', keys: ['other'] },
]
